import { useOrchestrator } from '../core/context';
export function useOrchestratorState() {
  const {
    isLoading,
    currentStep,
    currentParams
  } = useOrchestrator();
  return {
    isLoading,
    currentStep,
    currentParams
  };
}
//# sourceMappingURL=useOrchestratorState.js.map